/* LumaTag theme behavior: cart, buy box, countdown, hero demo, reveals. */
(function () {
  'use strict';

  var LT = (window.LT = window.LT || {});
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || LT.root || '/';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  var ICON = {
    plus: '<svg class="lt-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
    minus: '<svg class="lt-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>',
    shield: '<svg class="lt-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l7 3v5c0 4.500-3 8.300-7 10-4-1.700-7-5.500-7-10V6z"/><path d="M9 12l2.200 2.200L15.500 10"/></svg>',
    heart: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20s-7-4.300-7-10a4 4 0 017-2.600A4 4 0 0119 10c0 5.700-7 10-7 10z"/></svg>'
  };

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMoney(cents, trimZeros) {
    var format = LT.moneyFormat || '${{amount}}';
    var value = (Number(cents) || 0) / 100;
    function withSeparators(number, decimals, thousands, decimal) {
      var parts = number.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      var out;
      switch (key) {
        case 'amount_no_decimals': out = withSeparators(value, 0, ',', '.'); break;
        case 'amount_with_comma_separator': out = withSeparators(value, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': out = withSeparators(value, 0, '.', ','); break;
        case 'amount_with_apostrophe_separator': out = withSeparators(value, 2, "'", '.'); break;
        default: out = withSeparators(value, 2, ',', '.');
      }
      if (trimZeros) out = out.replace(/[.,]00$/, '');
      return out;
    });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var items = $$('.lt-reveal');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      var shown = 0;
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.style.setProperty('--d', Math.min(shown, 4) * 70 + 'ms');
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
        shown += 1;
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- Header ---------- */
  function initHeader() {
    var toggle = $('[data-lt-menu-toggle]');
    var menu = $('[data-lt-menu]');
    if (toggle && menu) {
      toggle.addEventListener('click', function () {
        var open = menu.hidden;
        menu.hidden = !open;
        toggle.setAttribute('aria-expanded', String(open));
      });
      menu.addEventListener('click', function (event) {
        if (event.target.closest('a')) {
          menu.hidden = true;
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    }
    $$('[data-lt-autosubmit]').forEach(function (select) {
      select.addEventListener('change', function () { if (select.form) select.form.submit(); });
    });
  }

  /* ---------- Countdown to a real end date ---------- */
  function initCountdown() {
    var sale = LT.sale || {};
    var nodes = $$('[data-lt-countdown]');
    if (!sale.end || !nodes.length) return;
    var end = new Date(sale.end).getTime();
    if (isNaN(end)) return;
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var timer;

    function tick() {
      var left = end - Date.now();
      if (left <= 0) {
        nodes.forEach(function (node) { node.hidden = true; });
        clearInterval(timer);
        return;
      }
      var d = Math.floor(left / 864e5);
      var h = Math.floor((left % 864e5) / 36e5);
      var m = Math.floor((left % 36e5) / 6e4);
      var s = Math.floor((left % 6e4) / 1e3);
      nodes.forEach(function (node) {
        node.hidden = false;
        var label = $('[data-lt-countdown-label]', node);
        if (label) label.textContent = sale.label || 'Offer ends in';
        var text = $('[data-lt-countdown-text]', node);
        if (text) text.textContent = (sale.label || 'Offer ends in') + ' ' + (d ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
        var map = { d: d, h: h, m: m, s: s };
        Object.keys(map).forEach(function (key) {
          var cell = $('[data-lt-' + key + ']', node);
          if (cell) cell.textContent = pad(map[key]);
        });
      });
    }
    tick();
    timer = setInterval(tick, 1000);
  }

  /* ---------- Hero vest demo ---------- */
  function initVest() {
    var vest = $('[data-lt-vest]');
    if (!vest) return;
    var stage = vest.closest('.lt-hero__stage') || vest;
    var digits = $('[data-lt-vest-digits]', vest);
    var status = $('[data-lt-vest-status]', vest);
    var hitButton = $('[data-lt-vest-hit]', vest);
    var flash = $('.lt-vest__flash', vest);
    var shot = $('[data-lt-shot]', stage);
    var start = parseInt(vest.getAttribute('data-lives'), 10) || 9;
    var lives = start;

    function render() {
      digits.textContent = (lives < 10 ? '0' : '') + lives;
      vest.classList.toggle('is-out', lives === 0);
      status.textContent = lives === 0 ? 'Tagged out. Tap to reset.' : lives + (lives === 1 ? ' life left' : ' lives left');
    }

    hitButton.addEventListener('click', function () {
      if (lives === 0) { lives = start; render(); return; }
      lives -= 1;
      render();
      if (reduceMotion || !hitButton.animate) return;
      if (shot) shot.animate([{ opacity: 0, transform: 'scaleX(0.1)' }, { opacity: 1, transform: 'scaleX(1)', offset: 0.35 }, { opacity: 0, transform: 'scaleX(1)' }], { duration: 260, easing: 'cubic-bezier(0.23, 1, 0.32, 1)' });
      flash.animate([{ opacity: 0.9 }, { opacity: 0 }], { duration: 420, delay: 70, easing: 'ease-out' });
      hitButton.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-5px) rotate(-1.5deg)' }, { transform: 'translateX(4px) rotate(1deg)' }, { transform: 'translateX(0)' }], { duration: 300, delay: 70, easing: 'ease-out' });
    });

    $$('[data-lt-team]', vest).forEach(function (button) {
      button.addEventListener('click', function () {
        $$('[data-lt-team]', vest).forEach(function (other) { other.classList.toggle('is-on', other === button); });
        var team = button.getAttribute('data-lt-team');
        vest.setAttribute('data-team', team);
        stage.setAttribute('data-team', team);
      });
    });
    render();
  }

  /* ---------- Blaster modes ---------- */
  function initModes() {
    $$('[data-lt-modes]').forEach(function (card) {
      var tabs = $$('[data-lt-mode]', card);
      var ammo = $('[data-lt-mode-ammo]', card);
      var dmg = $('[data-lt-mode-dmg]', card);
      var pips = $('[data-lt-mode-pips]', card);
      var hearts = $('[data-lt-mode-hearts]', card);
      var tip = $('[data-lt-mode-tip]', card);

      function fill(container, count, html) {
        container.innerHTML = new Array(count + 1).join(html);
        Array.prototype.forEach.call(container.children, function (child, index) {
          child.style.transitionDelay = Math.min(index * 28, 300) + 'ms';
          requestAnimationFrame(function () { requestAnimationFrame(function () { child.classList.add('is-in'); }); });
        });
      }

      function select(tab) {
        tabs.forEach(function (other) {
          var on = other === tab;
          other.classList.toggle('is-on', on);
          other.setAttribute('aria-selected', String(on));
        });
        var shots = parseInt(tab.getAttribute('data-ammo'), 10);
        var damage = parseInt(tab.getAttribute('data-dmg'), 10);
        ammo.textContent = shots;
        dmg.textContent = damage;
        tip.textContent = tab.getAttribute('data-tip');
        fill(pips, shots, '<i></i>');
        fill(hearts, damage, ICON.heart);
      }

      tabs.forEach(function (tab) { tab.addEventListener('click', function () { select(tab); }); });
      if (tabs[0]) select(tabs[0]);
    });
  }

  /* ---------- Cart ---------- */
  var cart = {
    drawer: null,
    lastFocus: null,

    request: function (path, body) {
      var options = { headers: { Accept: 'application/json' }, credentials: 'same-origin' };
      if (body) {
        options.method = 'POST';
        options.headers['Content-Type'] = 'application/json';
        options.body = JSON.stringify(body);
      }
      return fetch(root + path, options).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || 'Something went wrong.');
          return data;
        });
      });
    },

    refresh: function () {
      return cart.request('cart.js').then(cart.render);
    },

    render: function (data) {
      var count = data.item_count || 0;
      $$('[data-lt-cart-count]').forEach(function (badge) {
        var changed = badge.textContent !== String(count);
        badge.textContent = count;
        badge.hidden = count === 0;
        if (changed && count > 0) {
          badge.classList.remove('is-bump');
          void badge.offsetWidth;
          badge.classList.add('is-bump');
        }
      });
      $$('[data-lt-cart-total]').forEach(function (el) { el.textContent = formatMoney(data.total_price); });
      $$('[data-lt-cart-foot]').forEach(function (el) { el.hidden = count === 0; });

      var html = count === 0
        ? '<div class="lt-empty"><strong>Your cart is empty</strong><p>Pick a set and the game can start.</p><a class="lt-btn" href="' + root + '#buy" data-lt-cart-close>Choose your set</a></div>'
        : data.items.map(function (item) {
          var image = item.image ? '<img class="lt-item__img" src="' + escapeHtml(item.image) + '" width="76" height="76" alt="" loading="lazy">' : '<span class="lt-item__img lt-item__img--ph">' + ICON.shield + '</span>';
          var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<span class="lt-item__variant">' + escapeHtml(item.variant_title) + '</span>' : '';
          return '<div class="lt-item" data-key="' + escapeHtml(item.key) + '">' + image +
            '<div class="lt-item__info"><a class="lt-item__title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' + variant +
            '<div class="lt-qty"><button type="button" data-lt-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">' + ICON.minus + '</button>' +
            '<output aria-label="Quantity">' + item.quantity + '</output>' +
            '<button type="button" data-lt-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">' + ICON.plus + '</button></div>' +
            '<button class="lt-item__remove" type="button" data-lt-qty="0">Remove</button></div>' +
            '<div class="lt-item__price">' + formatMoney(item.final_line_price) + '</div></div>';
        }).join('');
      $$('[data-lt-cart-items]').forEach(function (el) { el.innerHTML = html; });
      return data;
    },

    change: function (key, quantity, row) {
      if (row) row.classList.add('is-busy');
      return cart.request('cart/change.js', { id: key, quantity: quantity }).then(cart.render).catch(function () { return cart.refresh(); });
    },

    open: function () {
      if (!cart.drawer) return;
      cart.lastFocus = document.activeElement;
      cart.drawer.classList.add('is-open');
      cart.drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      var panel = $('.lt-drawer__panel', cart.drawer);
      if (panel) panel.focus({ preventScroll: true });
    },

    close: function () {
      if (!cart.drawer || !cart.drawer.classList.contains('is-open')) return;
      cart.drawer.classList.remove('is-open');
      cart.drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (cart.lastFocus && cart.lastFocus.focus) cart.lastFocus.focus({ preventScroll: true });
    },

    init: function () {
      cart.drawer = $('[data-lt-drawer]');
      var onCartPage = !!$('.lt-cartpage');
      document.addEventListener('click', function (event) {
        var opener = event.target.closest('[data-lt-cart-open]');
        if (opener) {
          if (onCartPage) return;
          event.preventDefault();
          cart.open();
          return;
        }
        if (event.target.closest('[data-lt-cart-close]')) { cart.close(); return; }
        var qty = event.target.closest('[data-lt-qty]');
        if (qty) {
          var row = qty.closest('[data-key]');
          cart.change(row.getAttribute('data-key'), parseInt(qty.getAttribute('data-lt-qty'), 10), row);
        }
      });
      document.addEventListener('keydown', function (event) { if (event.key === 'Escape') cart.close(); });
      cart.refresh().catch(function () {});
    }
  };

  /* ---------- Buy box ---------- */
  function initBuy() {
    $$('[data-lt-buy]').forEach(function (section) {
      var form = $('form.lt-buy__form', section);
      if (!form) return;
      var radios = $$('[data-lt-variant]', form);
      var price = $('[data-lt-price]', section);
      var compare = $('[data-lt-compare]', section);
      var error = $('[data-lt-buy-error]', section);
      var atc = $('[data-lt-atc]', section);
      var atcLabel = $('[data-lt-atc-label]', section);
      var sticky = $('[data-lt-sticky]', section);
      var slides = $$('[data-lt-slide]', section);
      var thumbs = $$('[data-lt-thumb]', section);
      var addons = $$('[data-lt-addon]', form);

      function updateTotal() {
        var selected = radios.filter(function (radio) { return radio.checked; })[0];
        var sum = selected ? Number(selected.getAttribute('data-price')) : 0;
        addons.forEach(function (addon) {
          addon.closest('.lt-addon').classList.toggle('is-on', addon.checked);
          if (addon.checked) sum += Number(addon.getAttribute('data-price'));
        });
        $$('[data-lt-atc-price]', section).forEach(function (el) { el.textContent = formatMoney(sum, true); });
      }
      addons.forEach(function (addon) { addon.addEventListener('change', updateTotal); });

      function showImage(id) {
        if (!id || !slides.some(function (slide) { return slide.getAttribute('data-lt-slide') === String(id); })) return;
        slides.forEach(function (slide) { slide.classList.toggle('is-on', slide.getAttribute('data-lt-slide') === String(id)); });
        thumbs.forEach(function (thumb) { thumb.classList.toggle('is-on', thumb.getAttribute('data-lt-thumb') === String(id)); });
      }
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () { showImage(thumb.getAttribute('data-lt-thumb')); });
      });

      function sync(radio, withImage) {
        radios.forEach(function (other) { other.closest('.lt-set').classList.toggle('is-on', other === radio); });
        var cents = radio.getAttribute('data-price');
        var was = radio.getAttribute('data-compare');
        if (price) price.textContent = formatMoney(cents);
        if (compare) {
          compare.hidden = !was;
          if (was) compare.textContent = formatMoney(was);
        }
        updateTotal();
        var stickyVariant = $('[data-lt-sticky-variant]', section);
        if (stickyVariant) stickyVariant.textContent = radio.getAttribute('data-title');
        if (withImage) showImage(radio.getAttribute('data-image'));
      }
      radios.forEach(function (radio) {
        radio.addEventListener('change', function () { sync(radio, true); });
      });
      var checked = radios.filter(function (radio) { return radio.checked; })[0];
      if (checked) sync(checked, false);

      form.addEventListener('submit', function (event) {
        if (event.submitter && !event.submitter.hasAttribute('data-lt-atc') && !event.submitter.classList.contains('lt-sticky__btn')) return;
        var selected = radios.filter(function (radio) { return radio.checked; })[0];
        if (!selected || !window.fetch) return;
        event.preventDefault();
        if (error) error.hidden = true;
        atc.classList.add('is-loading');
        if (atcLabel) atcLabel.textContent = 'Adding';
        var items = [{ id: Number(selected.value), quantity: 1 }];
        addons.forEach(function (addon) { if (addon.checked) items.push({ id: Number(addon.value), quantity: 1 }); });
        cart.request('cart/add.js', { items: items })
          .then(cart.refresh)
          .then(function () {
            if ($('.lt-cartpage')) { window.location.href = LT.cartUrl || root + 'cart'; return; }
            cart.open();
          })
          .catch(function (err) {
            if (error) { error.textContent = err.message; error.hidden = false; }
          })
          .then(function () {
            atc.classList.remove('is-loading');
            if (atcLabel) atcLabel.textContent = 'Add to cart';
          });
      });

      if (sticky && atc && 'IntersectionObserver' in window) {
        var seen = false;
        new IntersectionObserver(function (entries) {
          var entry = entries[0];
          if (entry.isIntersecting) seen = true;
          var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          var show = seen && passed;
          sticky.classList.toggle('is-on', show);
          sticky.setAttribute('aria-hidden', String(!show));
          var button = $('button', sticky);
          if (button) button.tabIndex = show ? 0 : -1;
        }).observe(atc);
      }
    });
  }

  /* ---------- Delivery estimate ---------- */
  function initEta() {
    $$('[data-lt-eta]').forEach(function (node) {
      var min = parseInt(node.getAttribute('data-min'), 10);
      var max = parseInt(node.getAttribute('data-max'), 10);
      if (!min || !max || max < min) return;
      function addBusinessDays(days) {
        var date = new Date();
        while (days > 0) {
          date.setDate(date.getDate() + 1);
          var day = date.getDay();
          if (day !== 0 && day !== 6) days -= 1;
        }
        return date.toLocaleDateString(document.documentElement.lang || undefined, { month: 'short', day: 'numeric' });
      }
      $('[data-lt-eta-from]', node).textContent = addBusinessDays(min);
      $('[data-lt-eta-to]', node).textContent = addBusinessDays(max);
      node.hidden = false;
    });
  }

  function init() {
    initReveal();
    initHeader();
    initCountdown();
    initVest();
    initModes();
    cart.init();
    initBuy();
    initEta();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
